<template>
  <span
    class="record-privacy-toggle"
    @click.stop
  >
    <RecordPrivacy
      :record="record"
      interactive
      :loading="!!record.privacySaving"
      @toggle="save"
    />
    <v-snackbar
      v-model="notice"
      :timeout="7000"
      :color="error ? 'error' : undefined"
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="notice = false"
        >{{ $t("Close") }}</v-btn>
      </template>
    </v-snackbar>
  </span>
</template>

<script>
import axios from 'axios'
import { t } from '@/i18n'

import RecordPrivacy from './RecordPrivacy.vue'
import { privacyExplanations } from '../utils/recordPrivacy'

export default {
  components: { RecordPrivacy },
  props: { record: { type: Object, required: true } },
  data: () => ({ notice: false, message: '', error: false }),
  methods: {
    async save(isPublic) {
      if (this.record.privacySaving) return
      this.$set(this.record, 'privacySaving', true)
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_ROOT_API}/updateFileInfos`, {
          operation: 'privacy', file_id: this.record.id, public: isPublic,
        }, { headers: { Authorization: this.$store.state.jwtToken } })
        if (typeof data.effective_public !== 'boolean' || typeof data.public !== 'boolean') throw new Error('Invalid privacy response')
        this.$set(this.record, 'public', data.public)
        this.$set(this.record, 'effective_public', data.effective_public)
        this.$set(this.record, 'privacy_reason', data.privacy_reason)
        this.error = false
        this.message = data.public && !data.effective_public
          ? t('Record setting saved as Public. {{value0}}', { value0: t(privacyExplanations[data.privacy_reason] || privacyExplanations.unknown) })
          : t('Record is now {{value0}}.', { value0: data.effective_public ? t('Public') : t('Private') })
        this.notice = true
      } catch (e) {
        this.error = true
        this.message = t('Could not save visibility. Please try again.')
        this.notice = true
      } finally {
        this.$set(this.record, 'privacySaving', false)
      }
    },
  },
}
</script>

<style scoped>
.record-privacy-toggle { display: inline-flex; vertical-align: middle; }
</style>
